import React from 'react';
import PropTypes from 'prop-types';

import './styles/VideoBlock.scss';

const VideoBlock = ({ title, link, description}) => {
	return (
		<div className="VideoBlock">
			<h3 className="VideoBlock-title">{ title }</h3>
			{
				description &&
					<div className="VideoBlock-description">
						{ description }
					</div>
			}
			<div className="VideoBlock-link">
				<iframe
					src={link}
					frameBorder="0"
					allowFullScreen>
				</iframe>
			</div>
		</div>
	);
}

VideoBlock.defaultValues = {
	link: 'https://www.youtube.com/embed/V_6hy3SCNt0',
}

VideoBlock.propTypes = {
	link: PropTypes.string.isRequired,
	title: PropTypes.string,
	description: PropTypes.string,
}

export default VideoBlock;


// WEBPACK FOOTER //
// ./src/components/VideoBlock.jsx